const AiIconClose = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill="#E67D2D" />
    <path
      d="M42.5 23.615L40.385 21.5L32 29.885L23.615 21.5L21.5 23.615L29.885 32L21.5 40.385L23.615 42.5L32 34.115L40.385 42.5L42.5 40.385L34.115 32L42.5 23.615Z"
      fill="white"
    />
  </svg>
);

export default AiIconClose;
